import React, { useEffect, useRef, useState } from "react";
import { useDataContext } from "../../../data/providers/DataProvider";
import { useResearchDataContext } from "../providers/ResearchDataProvider";

import Select from 'react-select';

import {
    customSelectClearIndicator,
    customSelectControl,
    customSelectDropdownIndicator,
    customSelectMenu,
    customSelectMenuList,
    customSelectOption,
    customSelectPlaceholder,
    customSelectStyles,
    customSelectValueContainer
} from "../../global-components/select-customizer";
import RangeSlider from "../../global-components/ui/RangeSlider";


const ApartmentsMapSidebar = () => {

    const researchData = useResearchDataContext();
    const {apartments, apartmentPriceRanges, regions, municipalities} = useDataContext();

    const regionsSelectRef = useRef(null);
    const municipalitiesSelectRef = useRef(null);
    const levelSelectRef = useRef(null);
    const roomsNumberSelectRef = useRef(null);
    const toiletsNumberSelectRef = useRef(null);
    const priceRangeInputRef = useRef(null);
    const priceRangeTextInputRef = useRef(null);
    const [municipalitiesByRegion, setMunicipalitiesByRegion] = useState([]);
    const [disableMunicipalitiesSelect, setDisableMunicipalitiesSelect] = useState(true);

    const [priceRangeLimits, setPriceRangeLimits] = useState([]);

    useEffect(() => {
        if(regionsSelectRef.current){
            regionsSelectRef.current.setValue(researchData.apartmentRegion);
        }
        if(municipalitiesSelectRef.current){
            municipalitiesSelectRef.current.setValue(researchData.apartmentMunicipality);
        }
        if(levelSelectRef.current){
            levelSelectRef.current.setValue(researchData.apartmentLevel);
        }
        if(roomsNumberSelectRef.current){
            roomsNumberSelectRef.current.setValue(researchData.apartmentRoomsNumber);
        }
        if(toiletsNumberSelectRef.current){
            toiletsNumberSelectRef.current.setValue(researchData.apartmentToiletsNumber);
        }
        if(researchData.apartmentPriceRange){
            setPriceRangeLimits(researchData.apartmentPriceRange.split('-'));
            // console.log(priceRangeLimits)
        }
        // if(priceRangeInputRef.current){
        //     priceRangeInputRef.current.value = researchData.apartmentPriceRange;
        // }
        // if(priceRangeTextInputRef.current && researchData.apartmentPriceRange){
        //     const priceRangeLimits = researchData.apartmentPriceRange.split('-');
        //     priceRangeTextInputRef.current.value = `${priceRangeLimits[0]} FCFA - ${priceRangeLimits[1]} FCFA`;
        // }
    }, [
        researchData.apartmentLevel,
        researchData.apartmentMunicipality,
        researchData.apartmentPriceRange,
        researchData.apartmentRegion,
        researchData.apartmentRoomsNumber,
        researchData.apartmentToiletsNumber
    ]);

    /**
     * 
     * @param region 
     */
    const changeRegion = (region) => {
        researchData.setApartmentRegion(region);

        if(region === null || region === undefined){
            setMunicipalitiesByRegion([]);
            municipalitiesSelectRef.current.clearValue();
            setDisableMunicipalitiesSelect(true);
            // setIsValidComplainantRegion(false);
        }
        else{
            setMunicipalitiesByRegion(municipalities.filter((municipality) => municipality.region_id === region.id));
            setDisableMunicipalitiesSelect(false);

            if(researchData.apartmentMunicipality !== null &&
                    researchData.apartmentMunicipality !== null &&
                researchData.apartmentMunicipality?.region_id !== region.id){
                    municipalitiesSelectRef.current.clearValue();
            }
            // setIsValidComplainantRegion(true);
        }
    };

    return (
        <aside className="sidebar ltn__shop-sidebar">
            {/* <h3 className="mb-10">Filtres</h3> */}
            {/* <label className="mb-30">
                <small>About 9,620 results (0.62 seconds) </small>
            </label> */}
            {/* Advance Information widget */}
            <div className="widget ltn__menu-widget px-3">
                <h4 className="ltn__widget-title">Catégorie</h4>
                <ul>
                    <li>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="apartment_status"
                                id="apartmentToRent"
                                value="RENT"
                                checked={researchData.apartmentCategory === 'RENT'}
                                onChange={(e) => researchData.setApartmentCategory('RENT')}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="apartmentToRent"
                            >
                                À louer
                            </label>
                        </div>
                        <span className="category-count">{apartments.filter((h) => h.real_estate.status === 'RENT').length}</span>
                    </li>
                    <li>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="apartment_status"
                                id="apartmentToSale"
                                value="SALE"
                                checked={researchData.apartmentCategory === 'SALE'}
                                onChange={(e) => researchData.setApartmentCategory('SALE')}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="apartmentToSale"
                            >
                                À vendre
                            </label>
                        </div>
                        <span className="category-count">{apartments.filter((h) => h.real_estate.status === 'SALE').length}</span>
                    </li>
                    <li>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="apartment_status"
                                id="apartmentToRentAndToSale"
                                value=""
                                checked={researchData.apartmentCategory === null}
                                onChange={(e) => researchData.setApartmentCategory(null)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="apartmentToRentAndToSale"
                            >
                                Tout
                            </label>
                        </div>
                        <span className="category-count">{apartments.length}</span>
                    </li>
                </ul>
                <div className="py-3"></div>
                <Select
                    ref={regionsSelectRef}
                    components={{
                        Control: customSelectControl,
                        ClearIndicator: customSelectClearIndicator,
                        DropdownIndicator: customSelectDropdownIndicator,
                        Menu: customSelectMenu,
                        MenuList: customSelectMenuList,
                        Option: customSelectOption,
                        Placeholder: customSelectPlaceholder,
                        ValueContainer: customSelectValueContainer
                    }}
                    isClearable={true}
                    isSearchable={true}
                    menuPlacement='auto'
                    // menuPortalTarget={document.body}
                    name='region'
                    options={regions}
                    getOptionValue={(option) => option.id}
                    getOptionLabel={(option) => option.name}
                    placeholder='Région'
                    styles={customSelectStyles}
                    onChange={changeRegion}
                />
                <div className="py-3"></div>
                <Select
                    ref={municipalitiesSelectRef}
                    components={{
                        Control: customSelectControl,
                        ClearIndicator: customSelectClearIndicator,
                        DropdownIndicator: customSelectDropdownIndicator,
                        Menu: customSelectMenu,
                        MenuList: customSelectMenuList,
                        Option: customSelectOption,
                        Placeholder: customSelectPlaceholder,
                        ValueContainer: customSelectValueContainer
                    }}
                    isClearable={true}
                    isSearchable={true}
                    isDisabled={disableMunicipalitiesSelect}
                    menuPlacement='auto'
                    // menuPortalTarget={document.body}
                    name='municipality'
                    options={municipalitiesByRegion}
                    getOptionValue={(option) => option.id}
                    getOptionLabel={(option) => option.name}
                    placeholder='Commune'
                    styles={customSelectStyles}
                    onChange={researchData.setApartmentMunicipality}
                />
                <div className="py-3"></div>
                <Select
                    ref={levelSelectRef}
                    components={{
                        Control: customSelectControl,
                        ClearIndicator: customSelectClearIndicator,
                        DropdownIndicator: customSelectDropdownIndicator,
                        Menu: customSelectMenu,
                        MenuList: customSelectMenuList,
                        Option: customSelectOption,
                        Placeholder: customSelectPlaceholder,
                        ValueContainer: customSelectValueContainer
                    }}
                    isClearable={true}
                    isSearchable={true}
                    menuPlacement='auto'
                    // menuPortalTarget={document.body}
                    name='level'
                    options={[
                        {wording: "1er étage", value: "1"},
                        {wording: "2ème étage", value: "2"},
                        {wording: "3ème étage", value: "3"},
                        {wording: "4ème étage", value: "4"},
                        {wording: "5ème étage", value: "5"},
                        {wording: "6ème étage", value: "6"},
                        {wording: "7ème étage et plus", value: "7+"}
                    ]}
                    getOptionValue={(option) => option.value}
                    getOptionLabel={(option) => option.wording}
                    placeholder="Niveau"
                    styles={customSelectStyles}
                    onChange={researchData.setApartmentLevel}
                />
                <div className="py-3"></div>
                <Select
                    ref={roomsNumberSelectRef}
                    components={{
                        Control: customSelectControl,
                        ClearIndicator: customSelectClearIndicator,
                        DropdownIndicator: customSelectDropdownIndicator,
                        Menu: customSelectMenu,
                        MenuList: customSelectMenuList,
                        Option: customSelectOption,
                        Placeholder: customSelectPlaceholder,
                        ValueContainer: customSelectValueContainer
                    }}
                    isClearable={true}
                    isSearchable={true}
                    menuPlacement='auto'
                    // menuPortalTarget={document.body}
                    name='rooms_number'
                    options={[
                        {wording: "1", value: "1"},
                        {wording: "2", value: "2"},
                        {wording: "3", value: "3"},
                        {wording: "4 et plus", value: "4+"}
                    ]}
                    getOptionValue={(option) => option.value}
                    getOptionLabel={(option) => option.wording}
                    placeholder='Nombre de chambres'
                    styles={customSelectStyles}
                    onChange={researchData.setApartmentRoomsNumber}
                />
                <div className="py-3"></div>
                <Select
                    ref={toiletsNumberSelectRef}
                    components={{
                        Control: customSelectControl,
                        ClearIndicator: customSelectClearIndicator,
                        DropdownIndicator: customSelectDropdownIndicator,
                        Menu: customSelectMenu,
                        MenuList: customSelectMenuList,
                        Option: customSelectOption,
                        Placeholder: customSelectPlaceholder,
                        ValueContainer: customSelectValueContainer
                    }}
                    isClearable={true}
                    isSearchable={true}
                    menuPlacement='auto'
                    // menuPortalTarget={document.body}
                    name='toilets_number'
                    options={[
                        {wording: "1", value: "1"},
                        {wording: "2", value: "2"},
                        {wording: "3 et plus", value: "3+"}
                    ]}
                    getOptionValue={(option) => option.value}
                    getOptionLabel={(option) => option.wording}
                    placeholder='Nombre de toilettes'
                    styles={customSelectStyles}
                    onChange={researchData.setApartmentToiletsNumber}
                />
                <div className="py-3"></div>
                {/* Price Filter Widget */}
                <div className="widget--- ltn__price-filter-widget">
                    <h4 className="ltn__widget-title ltn__widget-title-border---">Filtrer par prix</h4>
                    <div className="price_filter">
                        {/* <div className="price_slider_amount d-flex align-items-center gap-2">
                            <input
                                type="text"
                                className="amount mb-4"
                                name="price_range_to_display"
                                placeholder="Fourchette de prix"
                                ref={priceRangeTextInputRef}
                            />
                            <input
                                type="hidden"
                                className="price-range"
                                name="price_range"
                                placeholder=""
                                ref={priceRangeInputRef}
                            />
                        </div>
                        <div className="slider-range" /> */}
                        <div className="position-relative">
                        {
                            apartmentPriceRanges &&
                            <RangeSlider
                                // min={125000}
                                // max={15200055}
                                min={apartmentPriceRanges.min_price}
                                max={apartmentPriceRanges.max_price}
                                onChange={({ min, max }) => {
                                    // console.log(`min = ${min}, max = ${max}`)
                                    researchData.setApartmentPriceRange(`${min}-${max}`);
                                }}
                                // leftSliderCurrentValue={priceRangeLimits ? parseInt(priceRangeLimits[0]) : 125000}
                                // rightSliderCurrentValue={priceRangeLimits ? parseInt(priceRangeLimits[1]) : 4500000}
                                // leftSliderCurrentValue={researchData.apartmentPriceRange ? parseInt(researchData.apartmentPriceRange.split('-')[0]) : apartmentPriceRanges.min_price}
                                // rightSliderCurrentValue={researchData.apartmentPriceRange ? parseInt(researchData.apartmentPriceRange.split('-')[1]) : apartmentPriceRanges.max_price}
                            />
                        }
                        </div>
                    </div>
                </div>
                {/* Price Filter Widget */}
            </div>
        </aside>
    );
}

export default ApartmentsMapSidebar;
